define.alias("shared/components/shared/upgrade/bonus-features", "preview-grid/components/shared/upgrade/bonus-features");